import consumer from './consumer';
import {
  embedSignature,
  onSignliftEvent,
  finalizeSignature,
  SIGNLIFT_EVENTS,
} from '../lib/signlift';

let signatureSubscription = null;
let docliftDoesNotAnswerTimer = null;
let iframe;
let signliftCleanup = null;

function showErrorStep() {
  document.getElementById('subscriptionStep2')?.classList.add('d-none');
  document.getElementById('subscriptionStep3')?.classList.add('d-none');
  document.getElementById('subscriptionStep4')?.classList.add('d-none');
  document.getElementById('subscriptionStepError')?.classList.remove('d-none');
}

function advanceProgressBar(step) {
  const progressBar = document.getElementById('subscriptionProgressBar');
  if (!progressBar) return;

  progressBar.classList.remove('w-25', 'w-50', 'w-75', 'w-100');
  progressBar.classList.add(`w-${25 * step}`);
}

function revealStep4() {
  document.getElementById('subscriptionStep2')?.classList.add('d-none');
  document.getElementById('subscriptionStep3')?.classList.add('d-none');
  document.getElementById('subscriptionStep4')?.classList.remove('d-none');

  advanceProgressBar(4);

  const breadcrumbElement3 = document.querySelector('.breadcrumb-element:nth-child(3)');
  breadcrumbElement3?.classList.remove('current');
  breadcrumbElement3?.classList.add('past');

  const breadcrumbElement4 = document.querySelector('.breadcrumb-element:nth-child(4)');
  breadcrumbElement4?.classList.remove('next');
  breadcrumbElement4?.classList.add('current');

  const currentStep = document.getElementById('current_step');
  if (currentStep) currentStep.textContent = '4';
}

function setupSignatureChannel() {
  function docliftDoesNotAnswer() {
    if (!(typeof iframe === 'object')) {
      consumer.disconnect();
      showErrorStep();
    }
  }

  function generateSignliftIframe(signingUrl, finalizeUrl) {
    const subscriptionStep3 = document.getElementById('subscriptionStep3');
    if (!subscriptionStep3) return;

    iframe = embedSignature(subscriptionStep3, signingUrl);
    if (iframe) iframe.style.height = '100%';

    signliftCleanup?.();
    signliftCleanup = onSignliftEvent(
      ({ type }) => {
        if (type === SIGNLIFT_EVENTS.SUCCESS) {
          finalizeSignature(finalizeUrl).finally(() => revealStep4());
        } else if (type === SIGNLIFT_EVENTS.ERROR) {
          showErrorStep();
        }
      },
      signingUrl,
      iframe,
    );
  }

  function generateContractIframe(documentUrl) {
    iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '86%';
    iframe.src = documentUrl;

    const subscriptionStep3 = document.getElementById('subscriptionStep3');
    subscriptionStep3?.prepend(iframe);

    const editSubscriptionForm = document.querySelector('.edit_subscription');
    editSubscriptionForm?.addEventListener('ajax:success', function (event) {
      document.getElementById('subscriptionStep3')?.classList.add('d-none');
      document.getElementById('subscriptionStep4')?.classList.remove('d-none');

      advanceProgressBar(4);

      const breadcrumbElement3 = document.querySelector('.breadcrumb-element:nth-child(3)');
      breadcrumbElement3?.classList.remove('current');
      breadcrumbElement3?.classList.add('past');

      const breadcrumbElement4 = document.querySelector('.breadcrumb-element:nth-child(4)');
      breadcrumbElement4?.classList.remove('next');
      breadcrumbElement4?.classList.add('current');

      const currentStep = document.getElementById('current_step');
      if (currentStep) currentStep.textContent = '4';
    });
  }

  function markDocumentReady() {
    clearTimeout(docliftDoesNotAnswerTimer);

    const contractLoadedButton = document.getElementById('contractLoadedButton');
    if (contractLoadedButton) contractLoadedButton.disabled = false;

    const subscriptionStep2 = document.getElementById('subscriptionStep2');
    const stepTitle = subscriptionStep2?.querySelector('#step-title');
    if (stepTitle) stepTitle.textContent = subscriptionStep2.dataset.titleInCaseOfDocReady;

    const stepImage = subscriptionStep2?.querySelector('#step-image');
    if (stepImage) stepImage.src = subscriptionStep2.dataset.imageInCaseOfDocReady;

    document.getElementById('generatingDocInProgressExplanations')?.classList.add('d-none');
    document.getElementById('generatingDocReadyExplanations')?.classList.remove('d-none');

    contractLoadedButton?.addEventListener('click', (_event) => {
      document.getElementById('subscriptionStep3')?.classList.remove('d-none');
      document.getElementById('subscriptionStep2')?.classList.add('d-none');

      advanceProgressBar(3);

      const breadcrumbElement2 = document.querySelector('.breadcrumb-element:nth-child(2)');
      breadcrumbElement2?.classList.remove('current');
      breadcrumbElement2?.classList.add('past');

      const breadcrumbElement3 = document.querySelector('.breadcrumb-element:nth-child(3)');
      breadcrumbElement3?.classList.remove('next');
      breadcrumbElement3?.classList.add('current');

      const currentStep = document.getElementById('current_step');
      if (currentStep) currentStep.textContent = '3';
    });
  }

  const signatureSubscriptionElement = document.getElementById('signature-subscription-id');
  if (!signatureSubscriptionElement) {
    return;
  }

  docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  signatureSubscription = consumer.subscriptions.create(
    { channel: 'SignatureChannel', subscription_id: signatureSubscriptionElement.dataset.id },
    {
      received(data) {
        try {
          switch (data.status) {
            case 'success':
              if (data.signing_url !== undefined) {
                generateSignliftIframe(data.signing_url, data.finalize_url);
                markDocumentReady();
              } else {
                generateContractIframe(data.document_url);
                markDocumentReady();
              }
              break;
            case 'signed':
              clearTimeout(docliftDoesNotAnswerTimer);
              revealStep4();
              break;
            case 'awaiting_finalization':
              clearTimeout(docliftDoesNotAnswerTimer);
              break;
            default:
              setTimeout(showErrorStep, 5000);
          }
        } catch {
          setTimeout(showErrorStep, 5000);
        }
      },
      rejected() {
        setTimeout(showErrorStep, 5000);
        this.uninstall();
      },
    },
  );
}

function teardownSignatureChannel() {
  if (signatureSubscription) {
    consumer.subscriptions.remove(signatureSubscription);
    signatureSubscription = null;
  }

  signliftCleanup?.();
  signliftCleanup = null;

  clearTimeout(docliftDoesNotAnswerTimer);
  docliftDoesNotAnswerTimer = null;
  iframe = undefined;
}

document.addEventListener('turbo:load', setupSignatureChannel);
document.addEventListener('turbo:before-cache', teardownSignatureChannel);
